module.exports = __webpack_public_path__ + "img/visualizar.94a09f37.svg";